export default "__VITE_ASSET__DrMKRjPK__"